import { loadStripe, type Stripe } from '@stripe/stripe-js'
import { stripeModeFromKey, type StripeMode } from '@parkify/ui/stripe-mode'

// Publishable key is build-time public (pk_…). Unified on
// VITE_STRIPE_PUBLISHABLE_KEY (same name as the consumer app); the older
// VITE_STRIPE_PUBLIC_KEY is still accepted as a fallback for existing env files.
const KEY =
  ((import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? import.meta.env.VITE_STRIPE_PUBLIC_KEY) as
    | string
    | undefined) ?? ''

// Memoize the loadStripe promise so the Stripe.js script is fetched once across
// the app lifetime.
let cached: Promise<Stripe | null> | null = null

export function stripeConfigured(): boolean {
  return KEY.length > 0
}

export function getStripe(): Promise<Stripe | null> {
  if (!stripeConfigured()) return Promise.resolve(null)
  if (!cached) cached = loadStripe(KEY)
  return cached
}

export type { StripeMode } from '@parkify/ui/stripe-mode'

// Mode embedded in this build's pk_*. A mismatch with the Worker's sk_* mode
// silently breaks Elements (the card form never mounts, the Pay button stays
// disabled, no console error) — see StripeModeGuard.
export function clientStripeMode(): StripeMode {
  return stripeModeFromKey(KEY)
}
